"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TourOrchestrator = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var TourPanel_1 = require("../TourPanel/TourPanel");
var classnames_1 = __importDefault(require("classnames"));
var moment_1 = __importDefault(require("moment"));
var TourPulse_1 = require("../Pulse/TourPulse");
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
var Tour_1 = require("@CommonFrontendBackend/Tour");
var TourTypes_1 = require("../Steps/TourTypes");
var TourConfetti_1 = __importDefault(require("./TourConfetti"));
var WELCOME_STEP_ID = "welcome";
var TourOrchestrator = (function () {
    function TourOrchestrator(scopeUi, mountReactComponent, telemetry, tourState, apiBaseUrl, rootDataStore, createAndEditTour, automationHubspotTour, onboardingStore) {
        var _a;
        var _this = this;
        this.scopeUi = scopeUi;
        this.mountReactComponent = mountReactComponent;
        this.telemetry = telemetry;
        this.apiBaseUrl = apiBaseUrl;
        this.onboardingStore = onboardingStore;
        this.discoverSidebarUTCReleaseDate = (0, moment_1.default)("2022-08-09T00:50:00.000Z");
        this.promptsEnabledForUser = false;
        this.hasMinimisedAtLeastOnce = false;
        this.startTour = function (_a) {
            var tourId = _a.tourId, startingStep = _a.startingStep;
            _this.inlinePromptsHistoryStore.dismissedPrompt(PromptTypes_1.PromptId.TourWelcome);
            var isResumingTour = !!_this.tourState.tours[tourId].currentStep;
            if (!isResumingTour && !startingStep) {
                _this.getTour(tourId).onTourStart();
            }
            if (startingStep) {
                _this.tourState.tours[tourId].currentStep = startingStep;
            }
            else if (_this.tours[tourId].defaultStartingStep) {
                _this.tourState.tours[tourId].currentStep = _this.tours[tourId].defaultStartingStep;
            }
            _this.tourState.currentlyRunningTour = tourId;
        };
        this.isTourCompleted = function (tourId) {
            return _this.tourState.tours[tourId].completed;
        };
        this.handleActionedPrompt = function () {
            _this.telemetry.track("Discover Sidebar Prompt Dismissed");
            _this.inlinePromptsHistoryStore.dismissedPrompt(PromptTypes_1.PromptId.DiscoverSidebar);
        };
        this.handleGoToStep = function (stepIndexToGoTo) {
            var stepToGoTo = _this.currentTour.steps[stepIndexToGoTo];
            if (stepToGoTo) {
                _this.tourState.tours[_this.currentTour.tourId].currentStep = stepToGoTo.step;
            }
            else {
                _this.finishTour();
            }
        };
        this.clearTour = function () {
            var _a, _b, _c;
            var tourId = (_a = _this.tourState.currentlyRunningTour) !== null && _a !== void 0 ? _a : _this.upNextTour.tourId;
            _this.telemetry.track("Onboarding Panel Dismissed", {
                onboarding_panel_flow: _this.getTour(tourId).telemetryId,
                onboarding_panel_step: (_b = _this.currentStepId) !== null && _b !== void 0 ? _b : WELCOME_STEP_ID,
                onboarding_panel_page_url: _this.pageUrl,
            }, { blockIdentify: true, blockIntercom: true });
            _this.inlinePromptsHistoryStore.dismissedPrompt(PromptTypes_1.PromptId.TourWelcome);
            if (((_c = _this.currentStep) === null || _c === void 0 ? void 0 : _c.stepType) === TourTypes_1.TourStepConfigurationType.Completion) {
                _this.finishTour();
            }
            else {
                _this.tourState.currentlyRunningTour = undefined;
            }
        };
        this.finishTour = function () {
            var currentlyRunningTour = _this.tourState.currentlyRunningTour;
            _this.tourState.currentlyRunningTour = undefined;
            _this.tourState.tours[currentlyRunningTour].completed = true;
            _this.tourState.tours[currentlyRunningTour].currentStep = undefined;
        };
        this.handleSkipTour = function () {
            var _a;
            _this.inlinePromptsHistoryStore.dismissedPrompt(PromptTypes_1.PromptId.TourWelcome);
            var currentlyRunningTour = _this.tourState.currentlyRunningTour;
            if (currentlyRunningTour) {
                _this.tourState.tours[currentlyRunningTour].currentStep = undefined;
                _this.tourState.currentlyRunningTour = undefined;
            }
            _this.telemetry.track("Onboarding Panel Skipped", {
                onboarding_panel_flow: (_a = _this.getTour(_this.upNextTour.tourId).telemetryId) !== null && _a !== void 0 ? _a : "",
                onboarding_panel_step: WELCOME_STEP_ID,
                onboarding_panel_page_url: _this.pageUrl,
            }, { blockIdentify: true, blockIntercom: true });
        };
        this.handleMinimiseTour = function () {
            var _a, _b;
            var tourId = (_a = _this.tourState.currentlyRunningTour) !== null && _a !== void 0 ? _a : _this.upNextTour.tourId;
            _this.telemetry.track("Onboarding Panel Minimised", {
                onboarding_panel_flow: _this.getTour(tourId).telemetryId,
                onboarding_panel_step: (_b = _this.currentStepId) !== null && _b !== void 0 ? _b : WELCOME_STEP_ID,
                onboarding_panel_page_url: _this.pageUrl,
            }, { blockIdentify: true, blockIntercom: true });
            _this.hasMinimisedAtLeastOnce = true;
        };
        this.getTour = function (tour) {
            return _this.tours[tour];
        };
        this.tourState = (0, lodash_1.cloneDeep)(tourState);
        this.promptsEnabledForUser = (0, moment_1.default)(rootDataStore.userDataStore.createdAt).isAfter(this.discoverSidebarUTCReleaseDate);
        this.inlinePromptsHistoryStore = rootDataStore.userDataStore.useHistoryDataStore.inlinePromptsHistoryStore;
        this.tours = (_a = {},
            _a[Tour_1.TourId.CreateAndEditTemplate] = createAndEditTour,
            _a[Tour_1.TourId.AutomationHubspot] = automationHubspotTour,
            _a);
    }
    TourOrchestrator.prototype.mountTourOrchestrator = function () {
        var _this = this;
        this.disposeTourStateReaction = (0, mobx_1.reaction)(function () { return (0, mobx_1.toJS)(_this.tourState); }, function (tourState) {
            axios_1.default.put("".concat(_this.apiBaseUrl, "/tour-state"), tourState, { withCredentials: true });
        }, { delay: 500 });
        this.disposeOnboardingPanelViewedReaction = (0, mobx_1.reaction)(function () { return (_this.tourState.currentlyRunningTour ? _this.currentStepId : undefined); }, function (currentStepInTourRunning) {
            var _a;
            if (currentStepInTourRunning) {
                var tour = _this.tourState.currentlyRunningTour;
                _this.telemetry.track("Onboarding Panel Viewed", {
                    onboarding_panel_step: currentStepInTourRunning,
                    onboarding_panel_flow: (_a = _this.getTour(tour).telemetryId) !== null && _a !== void 0 ? _a : "",
                    onboarding_panel_page_url: _this.pageUrl,
                }, { blockIdentify: true, blockIntercom: true });
            }
        }, {
            fireImmediately: true,
        });
        this.disposeOnboardingWelcomeViewedReaction = (0, mobx_1.reaction)(function () { return _this.shouldShowWelcome; }, function (showWelcome) {
            var _a;
            if (showWelcome) {
                _this.telemetry.track("Onboarding Panel Viewed", {
                    onboarding_panel_step: WELCOME_STEP_ID,
                    onboarding_panel_flow: (_a = _this.getTour(_this.upNextTour.tourId).telemetryId) !== null && _a !== void 0 ? _a : "",
                    onboarding_panel_page_url: _this.pageUrl,
                }, { blockIdentify: true, blockIntercom: true });
            }
        }, {
            fireImmediately: true,
        });
        this.scopeUi.tourRoot = this.mountReactComponent(react_1.default.createElement(mobx_react_1.Observer, null, function () { return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.helpZIndex }, function (_a) {
            var _b, _c;
            var zIndex = _a.zIndex;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_transition_group_1.Transition, { in: _this.tourState.currentlyRunningTour &&
                        ((_b = _this.currentStep) === null || _b === void 0 ? void 0 : _b.stepType) === TourTypes_1.TourStepConfigurationType.Welcome &&
                        !_this.hasMinimisedAtLeastOnce, mountOnEnter: true, unmountOnExit: true, timeout: kaleidoscope_2.AnimationDuration.Long, onEnter: utils_1.forceReflow }, function (status) { return (react_1.default.createElement("div", { style: { zIndex: zIndex }, className: (0, classnames_1.default)("tour-underlay", "tour-underlay--".concat(status)) })); }),
                react_1.default.createElement(TourConfetti_1.default, { show: ((_c = _this.currentStep) === null || _c === void 0 ? void 0 : _c.stepType) === TourTypes_1.TourStepConfigurationType.Completion }),
                react_1.default.createElement(react_transition_group_1.TransitionGroup, { component: null, timeout: kaleidoscope_2.AnimationDuration.Long }, (function () {
                    var shouldShowWelcome = _this.shouldShowWelcome;
                    var upNextTourStartArgs = _this.upNextTour;
                    var currentTour = _this.currentTour;
                    var currentStep = _this.currentStep;
                    var hasMinimisedAtLeastOnce = _this.hasMinimisedAtLeastOnce;
                    if (!(shouldShowWelcome && upNextTourStartArgs) && !(currentTour && currentStep)) {
                        return null;
                    }
                    var panelProps;
                    if (shouldShowWelcome) {
                        panelProps = {
                            currentStep: {
                                stepType: TourTypes_1.TourStepConfigurationType.Welcome,
                                title: "👋 Welcome to Qwilr",
                                description: upNextTourStartArgs.welcomeDescription,
                            },
                        };
                    }
                    else {
                        panelProps = {
                            currentStep: currentStep,
                            stepIndex: currentTour.steps.findIndex(function (s) { return s === currentStep; }),
                            onGoToStep: _this.handleGoToStep,
                            onFinishTour: _this.finishTour,
                            tourTelemetryId: currentTour.telemetryId,
                            steps: currentTour.steps,
                        };
                    }
                    if (upNextTourStartArgs) {
                        panelProps.onStartTour = function () { return _this.startTour(upNextTourStartArgs); };
                        panelProps.upNextTour = _this.getTour(upNextTourStartArgs.tourId);
                    }
                    return (react_1.default.createElement(react_transition_group_1.Transition, { in: true, timeout: kaleidoscope_2.AnimationDuration.Long, mountOnEnter: true, unmountOnExit: true, onEnter: utils_1.forceReflow }, function (status) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)("tour-panel-host", "tour-panel-host--".concat(status)), style: { zIndex: zIndex } },
                        react_1.default.createElement(TourPanel_1.TourPanel, __assign({}, panelProps, { onClosePanel: _this.clearTour, onSkip: _this.handleSkipTour, onMinimise: _this.handleMinimiseTour })),
                        shouldShowWelcome && !hasMinimisedAtLeastOnce && react_1.default.createElement(TourPulse_1.TourPulse, null))); }));
                })())));
        })); }), {
            onDestroy: function () {
                var _a, _b, _c;
                (_a = _this.disposeTourStateReaction) === null || _a === void 0 ? void 0 : _a.call(_this);
                (_b = _this.disposeOnboardingPanelViewedReaction) === null || _b === void 0 ? void 0 : _b.call(_this);
                (_c = _this.disposeOnboardingWelcomeViewedReaction) === null || _c === void 0 ? void 0 : _c.call(_this);
            },
        });
    };
    Object.defineProperty(TourOrchestrator.prototype, "shouldShowPrompt", {
        get: function () {
            return (this.promptsEnabledForUser &&
                !this.shouldShowWelcome &&
                !this.inlinePromptsHistoryStore.hasDismissed(PromptTypes_1.PromptId.DiscoverSidebar) &&
                !this.tourState.currentlyRunningTour);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TourOrchestrator.prototype, "shouldShowWelcome", {
        get: function () {
            return (this.promptsEnabledForUser &&
                !this.onboardingStore.shouldShowCensusCollector &&
                !this.inlinePromptsHistoryStore.hasDismissed(PromptTypes_1.PromptId.TourWelcome) &&
                !!this.upNextTour);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TourOrchestrator.prototype, "currentStepId", {
        get: function () {
            var _a, _b;
            if (!this.currentTour) {
                return undefined;
            }
            var storedCurrentStep = (_a = this.tourState.tours[this.tourState.currentlyRunningTour]) === null || _a === void 0 ? void 0 : _a.currentStep;
            var storedStepExists = this.currentTour.steps.find(function (step) { return step.step === storedCurrentStep; });
            if (!storedCurrentStep || !storedStepExists) {
                return (_b = this.currentTour) === null || _b === void 0 ? void 0 : _b.steps[0].step;
            }
            else {
                return storedCurrentStep;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TourOrchestrator.prototype, "currentTour", {
        get: function () {
            return this.tours[this.tourState.currentlyRunningTour];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TourOrchestrator.prototype, "currentStep", {
        get: function () {
            var _a;
            return (_a = this.currentTour) === null || _a === void 0 ? void 0 : _a.stepById(this.currentStepId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TourOrchestrator.prototype, "upNextTour", {
        get: function () {
            var _this = this;
            var availableTours = Object.values(this.tours).filter(function (tour) {
                if (tour.enabled && tour.priority.order) {
                    var isCompleted = _this.tourState.tours[tour.tourId].completed;
                    var hasBeenStarted = !!_this.tourState.tours[tour.tourId].currentStep;
                    return !isCompleted && !hasBeenStarted;
                }
                return false;
            });
            if (availableTours.length === 0) {
                return null;
            }
            var upNext = (0, lodash_1.last)((0, lodash_1.sortBy)(availableTours, "priority.order"));
            return {
                tourId: upNext.tourId,
                welcomeDescription: upNext.welcomeDescription,
                startingStep: upNext.priority.startingStep,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TourOrchestrator.prototype, "pageUrl", {
        get: function () {
            return window.location.hash.substring(1);
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Object)
    ], TourOrchestrator.prototype, "tourState", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], TourOrchestrator.prototype, "hasMinimisedAtLeastOnce", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TourOrchestrator.prototype, "startTour", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TourOrchestrator.prototype, "shouldShowPrompt", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TourOrchestrator.prototype, "shouldShowWelcome", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TourOrchestrator.prototype, "handleActionedPrompt", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TourOrchestrator.prototype, "handleGoToStep", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TourOrchestrator.prototype, "clearTour", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TourOrchestrator.prototype, "finishTour", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TourOrchestrator.prototype, "handleSkipTour", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TourOrchestrator.prototype, "handleMinimiseTour", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof Tour_1.StepTypeForTourId !== "undefined" && Tour_1.StepTypeForTourId) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], TourOrchestrator.prototype, "currentStepId", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_b = typeof TourTypes_1.Tour !== "undefined" && TourTypes_1.Tour) === "function" ? _b : Object),
        __metadata("design:paramtypes", [])
    ], TourOrchestrator.prototype, "currentTour", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof TourTypes_1.StepConfiguration !== "undefined" && TourTypes_1.StepConfiguration) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], TourOrchestrator.prototype, "currentStep", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], TourOrchestrator.prototype, "upNextTour", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], TourOrchestrator.prototype, "pageUrl", null);
    return TourOrchestrator;
}());
exports.TourOrchestrator = TourOrchestrator;
